import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzSmdBl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_SMD_BL: Record<
  PageIdWoofzSmdBl,
  TPageConfig
> = {
  [PageIdWoofzSmdBl.DOG_AGE_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_AGE_SMD_BL,
    hasHeader: true,
  },
  [PageIdWoofzSmdBl.DOG_SEX_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_SEX_SMD_BL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.DOG_BREED_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_BREED_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.URGE_SMD_BL]: {
    id: PageIdWoofzSmdBl.URGE_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.GOALS_SMD_BL]: {
    id: PageIdWoofzSmdBl.GOALS_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.URGE_1_SMD_BL]: {
    id: PageIdWoofzSmdBl.URGE_1_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.AGRESSIVE_BEHAVIOR_SMD_BL]: {
    id: PageIdWoofzSmdBl.AGRESSIVE_BEHAVIOR_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.TRIGGERS_SMD_BL]: {
    id: PageIdWoofzSmdBl.TRIGGERS_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.URGE_2_SMD_BL]: {
    id: PageIdWoofzSmdBl.URGE_2_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.BEHAVIOR_ISSUES_SMD_BL]: {
    id: PageIdWoofzSmdBl.BEHAVIOR_ISSUES_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.DOG_LISTEN_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_LISTEN_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.COMMANDS_SMD_BL]: {
    id: PageIdWoofzSmdBl.COMMANDS_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.EAT_OFF_THE_GROUND_SMD_BL]: {
    id: PageIdWoofzSmdBl.EAT_OFF_THE_GROUND_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.DOG_ACT_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_ACT_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.DOG_OFF_AT_HOME_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_OFF_AT_HOME_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.PREPARE_SCREEN_SMD_BL]: {
    id: PageIdWoofzSmdBl.PREPARE_SCREEN_SMD_BL,
    hasHeader: true,
  },
  [PageIdWoofzSmdBl.DOG_PROFILE_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOG_PROFILE_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.HEAR_ABOUT_WOOFZ_SMD_BL]: {
    id: PageIdWoofzSmdBl.HEAR_ABOUT_WOOFZ_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.MANNERS_TO_BUILD_SMD_BL]: {
    id: PageIdWoofzSmdBl.MANNERS_TO_BUILD_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.FEEL_BETTER_SMD_BL]: {
    id: PageIdWoofzSmdBl.FEEL_BETTER_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzSmdBl.PREPARE_FLOW_SMD_BL]: {
    id: PageIdWoofzSmdBl.PREPARE_FLOW_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.EMAIL_SMD_BL]: {
    id: PageIdWoofzSmdBl.EMAIL_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.NEWSLETTER_URGE_SMD_BL]: {
    id: PageIdWoofzSmdBl.NEWSLETTER_URGE_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.SCRATCH_SCREEN_SMD_BL]: {
    id: PageIdWoofzSmdBl.SCRATCH_SCREEN_SMD_BL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzSmdBl.SUBSCRIPTIONS_SMD_BL]: {
    id: PageIdWoofzSmdBl.SUBSCRIPTIONS_SMD_BL,
  },
  [PageIdWoofzSmdBl.CHAT_UPSELL_SMD_BL]: {
    id: PageIdWoofzSmdBl.CHAT_UPSELL_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmdBl.UPSELL_SMD_BL]: {
    id: PageIdWoofzSmdBl.UPSELL_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmdBl.UPSELL_FEEDING_GUIDE_SMD_BL]: {
    id: PageIdWoofzSmdBl.UPSELL_FEEDING_GUIDE_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmdBl.UPSELL_EMOTIONAL_SUPPORT_SMD_BL]: {
    id: PageIdWoofzSmdBl.UPSELL_EMOTIONAL_SUPPORT_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmdBl.DOWNLOAD_SMD_BL]: {
    id: PageIdWoofzSmdBl.DOWNLOAD_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzSmdBl.ACCOUNT_SMD_BL]: {
    id: PageIdWoofzSmdBl.ACCOUNT_SMD_BL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
